import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormCheckbox } from "components/form-fields";
import "./AutoSave.css";

export function AutoSave({
  isDisabled = false,
  defaultChecked = false,
  lastAutoSaveTime = null,
  forceShowSaveTime = false,
  onAutoSaveChange = null
}) {
  const [autoSaveEnabled, setAutoSaveEnabled] = useState(defaultChecked);
  const [lastAutoSaveText, setLastAutoSaveText] = useState(null);

  const secondsInMinute = 60;
  const secondsInHour = 3600;

  useEffect(() => {
    const updateInterval = setInterval(() => {
      setLastAutoSaveText(getLastAutoSaveText());
    }, 10000); // Update every 10 seconds

    return () => clearInterval(updateInterval);
  }, []);

  useEffect(() => {
    setLastAutoSaveText(getLastAutoSaveText());
  }, [lastAutoSaveTime]);

  const getLastAutoSaveText = () => {
    if (!lastAutoSaveTime) return null;

    const now = Date.now();
    const diffInSeconds = Math.floor((now - lastAutoSaveTime) / 1000);

    if (diffInSeconds < 10) {
      return "Saved recently";
    } else if (diffInSeconds < secondsInMinute) {
      const seconds = Math.floor(diffInSeconds / 10) * 10;
      return `Saved ${seconds} seconds ago`;
    } else if (diffInSeconds < secondsInHour) {
      const minutes = Math.floor(diffInSeconds / secondsInMinute);
      return `Saved ${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else {
      const hours = Math.floor(diffInSeconds / secondsInHour);
      return `Saved ${hours} hour${hours > 1 ? "s" : ""} ago`;
    }
  };

  const handleAutoSaveChanged = (event) => {
    const isChecked = event.target.checked;
    setAutoSaveEnabled(isChecked);
    if (onAutoSaveChange !== null) {
        onAutoSaveChange(isChecked);
    }
  };

  return (
    <div className="auto-save-container">
      <div className="inline-items auto-save-content">
        <span>Enable auto-save</span>
        <div className="auto-save-checkbox">
          <FormCheckbox
            checked={autoSaveEnabled}
            onChange={handleAutoSaveChanged}
            disabled={isDisabled}
          />
        </div>
      </div>
      <div className="auto-save-status">
        {(autoSaveEnabled || forceShowSaveTime) && lastAutoSaveTime && (
          <div className="half-size-text">
            {lastAutoSaveText}
          </div>
        )}
      </div>
    </div>
  );
}

AutoSave.propTypes = {
    isDisabled: PropTypes.bool,
    defaultChecked: PropTypes.bool,
    lastAutoSaveTime: PropTypes.number,
    forceShowSaveTime: PropTypes.bool,
    onAutoSaveChange: PropTypes.func
};
